import React from 'react'
import { NavLink } from 'react-router-dom'

export const DashboardMenus = props => {
    const { data, loading } = props

    return (
        <div className="dashboard-table">
            <div
                className="table-column"
                style={{
                    color: '#338CE4',
                }}
            >
                <div className="header">Navigation manager</div>
                <div className="view-all">
                    <NavLink to="/menus" activeClassName="active">
                        View All
                    </NavLink>
                </div>
            </div>
            {loading ? (
                <div className="table-column">Orders Loading...</div>
            ) : (
                <div>
                    {!data || data <= 1 ? (
                        <div className="table-column">No results found</div>
                    ) : (
                        <div>
                            <div
                                className="table-column"
                                style={{
                                    color: '#212529',
                                }}
                            >
                                <div style={{ width: '50%' }}>Name</div>
                                <div style={{ textAlign: 'center', width: '50%' }}>Locale</div>
                            </div>
                            {data.map(menu => (
                                <div key={menu.code} className="table-column">
                                    <div style={{ color: '#338CE4', width: '50%' }}>
                                        <NavLink
                                            to={`/menus/${menu.code}`}
                                            activeClassName="active"
                                        >
                                            {menu.name}
                                        </NavLink>
                                    </div>
                                    <div style={{ textAlign: 'center', width: '50%' }}>
                                        {menu.locale}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
